import { httpResource } from '@angular/common/http';
import { Service, computed, inject, signal } from '@angular/core';
import { GenderClient } from '@shared/api/leads/clients/gender.client';
import type { GendersResponse } from '@shared/api/leads/dtos/responses/genders.response';

@Service()
export class GenderReferenceService {
  private readonly client = inject(GenderClient);

  private readonly requested = signal(false);

  private readonly request = httpResource<GendersResponse>(() => (this.requested() ? this.client.buildGendersRequest() : undefined));

  readonly genders = computed(() => (this.request.hasValue() ? (this.request.value().genders ?? []) : []));

  readonly isUnavailable = computed(() => this.request.status() === 'error');

  readonly error = this.request.error;

  readonly isLoading = this.request.isLoading;

  load(): void {
    this.requested.set(true);
  }

  reload(): void {
    this.request.reload();
  }

  clear(): void {
    this.requested.set(false);
  }
}
